<template>
  <div class="stock-cart">
    <ContentHeader
      path-set-type="append"
      :show-back="true"
      :path-info="navPathInfo"
    />
    <div class="content-container" v-loading="loading">
      <!-- 购物车列表 -->
      <el-table
        :data="stockCartItemList"
        class="while-data-table"
        ref="stockCartItemForm"
        @selection-change="handleSelectChange"
      >
        <el-table-column
          type="selection"
          width="40"
          :selectable="checkRowSelectable"
        />
        <el-table-column label="商品名称" prop="itemName" />
        <el-table-column label="商品编码" prop="itemCode" />
        <el-table-column
          prop="quotaName"
          label="所属配额"
          v-if="moduleTypeName === 'money'"
        />
        <el-table-column label="所在仓库" prop="warehouseName" />
        <el-table-column
          v-if="moduleTypeName === 'stock'"
          label="可用库存"
          prop="logicalStock"
        />
        <el-table-column
          v-if="moduleTypeName === 'quota'"
          label="可用配额"
          prop="availableQuota"
        />
        <el-table-column
          v-if="moduleTypeName === 'apply'"
          label="可用数量"
          prop="availableAmount"
        />
        <el-table-column
          v-if="moduleTypeName === 'money'"
          label="可用库存"
          prop="availableAmount"
        />
        <el-table-column label="单价" v-if="moduleTypeName === 'money'">
          <template slot-scope="scope">
            <span>￥{{ scope.row.itemPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column label="数量" min-width="120px">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.itemQuantity"
              size="mini"
              :min="1"
              :precision="0"
              @change="setItemQty(scope.row)"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="小计" v-if="moduleTypeName === 'money'">
          <template slot-scope="scope">
            <span>￥{{ getItemAmount(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属模块" prop="moduleName" />
        <el-table-column label="区域编码" prop="orgCode" />
        <el-table-column label="品牌部门" prop="buTypeName" />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="icon-star">
              <i
                class="iconfont iconzu17 cursor"
                title="删除物料"
                @click="deleteRowItem(scope.row)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-row
        class="while-data-table-footer cart-footer"
        v-if="stockCartItemList.length"
      >
        <el-col :span="1">
          <el-checkbox v-model="allChecked" @change="onAllChecked" />
        </el-col>
        <el-col :span="11" class="text-left">全选</el-col>
        <el-col :span="12" class="text-right">
          <span class="cart-footer-opt" @click="deleteItem">删除选中物料</span>
        </el-col>
      </el-row>

      <div class="cart-item-list">
        <div class="summary-line">
          <div class="text">
            物料共 <span class="text-underline">{{ totalCount }}</span> 件
          </div>
          <div class="text">
            已选择 <span class="text-underline">{{ selectedCount }}</span> 件
          </div>
          <div class="text" v-if="moduleTypeName === 'money'">
            商品合计 ￥ <span class="text-underline">{{ allAmount }}</span>
          </div>
        </div>

        <div class="button-line">
          <el-button class="btn-red" @click="doSettlement">
            确认下单 <i class="iconfont iconzu121" />
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '../../components/content-header'
import { commonUtils } from '@/utils/common'
import { create, all } from 'mathjs/number'
const math = create(all)
export default {
  name: 'stock-cart',
  components: {
    ContentHeader
  },
  data () {
    return {
      allChecked: false,
      loading: false,
      stockCartItemList: [],
      selectedCount: 0,
      moduleTypeName: '',
      moduleType: '',
      checkedCartIdList: []
    }
  },
  computed: {
    navPathInfo () {
      let pathInfo = {}
      switch (this.moduleTypeName) {
        case 'stock':
          pathInfo = { path: '/stock/stock', name: '库存' }
          break
        case 'quota':
          pathInfo = { path: '/stock/quota', name: '物资领用' }
          break
        case 'apply':
          pathInfo = { path: '/stock/apply', name: '物资申请' }
          break
        case 'money':
          pathInfo = { path: '/stock/money', name: '金额配额' }
          break
        default:
          break
      }
      return [pathInfo]
    },
    totalCount () {
      return this.stockCartItemList ? this.stockCartItemList.length : 0
    },
    allAmount () {
      let total = 0
      if (this.stockCartItemList) {
        this.stockCartItemList.forEach(item => {
          if (item.checked) {
            total = total + item.getItemAmount
          }
        })
      }
      return Number(commonUtils.formatNumber(total)).toFixed(2)
    }
  },
  created () {
    this.moduleTypeName = this.$route.query.moduleTypeName
    this.init()
  },
  methods: {
    init () {
      this.getModuleType()
      this.queryStockCartList()
    },
    getModuleType () {
      switch (this.moduleTypeName) {
        case 'stock':
          this.moduleType = '01'
          break
        case 'quota':
          this.moduleType = '02'
          break
        case 'apply':
          this.moduleType = '03'
          break
        case 'money':
          this.moduleType = '04'
          break
        default:
          break
      }
    },
    //  获取物料清单列表
    queryStockCartList () {
      let params = {
        moduleType: this.moduleType
      }
      this.loading = true
      this.$store
        .dispatch('queryStockCartList', params)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.stockCartItemList = []
            if (res.data.resultData.stockShoppingCartList) {
              this.stockCartItemList =
                res.data.resultData.stockShoppingCartList
              this.stockCartItemList.forEach(item => {
                this.$set(item, 'checked', false)
                this.$set(item, 'getItemAmount', 0)
              })
            }
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 商品价格小计
    getItemAmount (row) {
      let price = 0
      if (row.itemQuantity && row.itemPrice) {
        price = commonUtils.formatNumber(
          math.multiply(row.itemQuantity, row.itemPrice)
        )
      }
      row.getItemAmount = price
      return price
    },
    // 限制类别,出库用可用库存判断，配额用可用配额判断，物资申请用可用数量判断
    checkType (row) {
      let limit = 0
      switch (this.moduleTypeName) {
        case 'stock':
          limit = row.logicalStock
          break
        case 'quota':
          limit = row.availableQuota
          break
        case 'apply':
          limit = row.availableAmount
          break
        case 'money':
          limit = row.availableAmount
          break
      }
      return limit
    },
    // 检查数量
    checkQty (row) {
      let limit = this.checkType(row)
      if (row.itemQuantity > limit) {
        this.queryStockCartList()
        this.$message.error('超出可用数量，请重新操作')
        return false
      }
      if (!row.itemQuantity) {
        this.queryStockCartList()
        this.$message.error('数量为空，请重新操作')
        return false
      }
      if (this.moduleTypeName === 'money') {
        this.$nextTick(() => {
          if (row.getItemAmount > row.availableQuota) {
            this.$message.warning('商品小计已超过该配额的可用金额')
          }
        })
      }
      return true
    },
    // 数量改变时
    setItemQty (row) {
      if (!this.checkQty(row)) {
        return
      }
      let params = {
        cartId: row.cartId,
        moduleType: this.moduleType,
        itemQuantity: row.itemQuantity
      }
      this.$nextTick(() => {
        this.$store
          .dispatch('updateStockCart', params)
          .then(res => {
            if (res.data.resultCode === '0') {
            }
          })
          .catch(() => {
            this.$$message.error('修改数量失败')
          })
      })
    },

    // 全选
    onAllChecked () {
      this.$refs.stockCartItemForm.toggleAllSelection()
    },

    // 选中
    handleSelectChange (selectedItem) {
      if (!selectedItem) {
        this.$refs.stockCartItemForm.clearSelection()
        return true
      }
      this.stockCartItemList.forEach(item => {
        item.checked = false
      })
      this.checkedCartIdList = []

      // 选中的checked设为true
      selectedItem.forEach(item => {
        item.checked = true
      })

      // 记录被选中的cartId
      this.stockCartItemList.forEach(item => {
        if (item.checked) {
          this.checkedCartIdList.push(item.cartId)
        }
      })
      this.selectedCount = this.checkedCartIdList.length

      // 是否显示全选
      if (selectedItem.length === this.stockCartItemList.length) {
        this.allChecked = true
      } else {
        this.allChecked = false
      }
    },

    // 删除单行物料
    deleteRowItem (row) {
      this.$confirm('是否确认删除该商品', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = { cartIds: row.cartId }
          this.$store
            .dispatch('deleteStockCarts', params)
            .then(res => {
              if (res.data.resultCode === '0') {
                this.stockCartItemList.forEach((item, index) => {
                  if (item.cartId === row.cartId) {
                    this.stockCartItemList.splice(index, 1)
                  }
                })
                this.$message.success('删除成功')
              }
            })
            .catch(() => {
              this.$message.error('删除失败')
            })
        })
        .catch(() => {})
    },

    // 删除选择的物料
    deleteItem () {
      if (this.checkedCartIdList.length === 0) {
        this.$message.error('暂无可操作商品')
        return
      }
      this.$confirm('是否确认删除所选商品', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = { cartIds: this.checkedCartIdList.join(',') }
          this.$store
            .dispatch('deleteStockCarts', params)
            .then(res => {
              if (res.data.resultCode === '0') {
                this.queryStockCartList()
                this.$message.success('删除成功')
              }
            })
            .catch(() => {
              this.$message.error('删除失败')
            })
        })
        .catch(() => {})
    },

    // 确认下单
    doSettlement () {
      if (this.checkedCartIdList.length === 0) {
        this.$message.error('暂无可操作商品')
        return
      }
      let params = {
        cartIds: this.checkedCartIdList.join(','),
        moduleType: this.moduleType
      }
      this.$store
        .dispatch('stockCartSettlement', params)
        .then(res => {
          if (res.data.resultCode === '0') {
            this.goToView()
          }
        })
        .catch(() => {
          this.$message.error('下单失败')
        })
    },

    // 页面跳转
    goToView () {
      this.$router.push({
        path: '/stock/fill-order',
        query: { type: this.moduleTypeName + '-cart' }
      })
    },
    checkRowSelectable (row) {
      let limit = this.checkType(row)
      if (limit <= 0) {
        return false
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.stock-cart {
  .content-container {
    .cart-footer {
      margin-top: 16px;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      height: 48px;
      background-color: $base-white;
      padding: 16px 0;

      .cart-footer-opt {
        color: $base-plain;
        margin-right: 20px;
        cursor: pointer;
      }
    }

    .summary-line {
      margin-top: 16px;
      background-color: $base-lightpink;
      border-radius: 8px;
      height: 36px;
      padding: 24px 0 0 0;

      .text {
        display: inline-block;
        line-height: 16px;
        margin: 0 10px;

        .deduct-amount {
          color: $base-red;
          font-size: $font-20;
          font-weight: 700;
        }
      }
    }

    .cart-item-list {
      margin-top: 24px;
      text-align: center;

      .list-header {
        color: $base-plain;
        line-height: 48px;
        background-color: $base-white;

        &:first-child {
          border-top-left-radius: 8px;
        }

        &:last-child {
          border-top-right-radius: 8px;
        }
      }
    }

    .button-line {
      height: 80px;
      padding-top: 30px;
    }
  }
}
</style>
